import {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {useInvoice} from './hooks'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Select from 'react-select'
import {
	usePackages,
	useMerchandiseItems,
	useAvailableSubscriptions
} from '../hooks'
import {useClients} from '../../users/hooks'
import {dateToAPIStandard} from '../../../util/datetime'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {
	setEditor,
	editInvoice,
	createInvoice
} from './slice'
import DatePicker from "react-datepicker"

const Packages = ({status,packages,value,onSelect})=>{
	return (
		<div>
			<strong>Select a package</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Package</option>
				{packages.map(pkg=>(
					<option key={pkg.package_id} value={pkg.package_id}>
						{pkg.package_name}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const Subscriptions = ({status,value,subscriptions,onSelect})=>{
	return (
		<div>
			<strong>Select a Subscription</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Subscription</option>
				{subscriptions.map(sub=>(
					<option key={sub.subscription_id} value={sub.subscription_id}>
						{sub.name}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const Merchandise = ({status,value,merchandise,onSelect})=>{
	return (
		<div>
			<strong>Select a Product</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Product</option>
				{merchandise.map(product=>(
					<option key={product.id} value={product.id}>
						{product.title}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const CustomPayment = ({value,onChange})=>{
	return (
		<div>
			<strong>Payment Amount</strong>
			<Form.Control
				onChange={e=>{onChange(e.target.value)}}
				placeholder="Amount"
				value={value}
			/>
		</div>
	)
}

const Editor = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const {show,id} = useSelector(state=>state.invoices.editor)
	const invoice = useInvoice(id)
	console.log(invoice)
	const onHide = ()=>{
		dispatch(setEditor({
			show:false,
			id:false
		}))
	}
	const {status:packagesStatus,packages} = usePackages()
	const {status:subscriptionsStatus,subscriptions} = useAvailableSubscriptions()
	const {status:merchandiseStatus,merchandise} = useMerchandiseItems()
	const {status:clientsStatus,clients} = useClients()

	const [selectedItemType,setSelectedItemType] = useState('package')
	const [dueDate,setDueDate] = useState(new Date())
	const [selectedItemId,setSelectedItemId] = useState(0)
	const [qty,setQty] = useState('')
	const [paymentAmount,setPaymentAmount] = useState('')
	const optionsMap = {
		package:{
			text:'Packages',
			component:(
				<Packages
					status={packagesStatus}
					packages={packages}
					onSelect={setSelectedItemId}
					value={selectedItemId}
				/>
			)
		},
		subscription:{
			text:'Subscriptions',
			component:(
				<Subscriptions
					status={subscriptionsStatus}
					subscriptions={subscriptions}
					onSelect={setSelectedItemId}
					value={selectedItemId}
				/>
			)
		},
		merchandise:{
			text:'Merchandise',
			component:(
				<Merchandise
					status={merchandiseStatus}
					merchandise={merchandise}
					onSelect={setSelectedItemId}
					value={selectedItemId}
				/>
			)
		},
		session:{
			text:'Sessions',
			//sessions don't need a component
			component:null
		},
		custom_payment:{
			text:'Custom Payment',
			component:(
				<CustomPayment
					value={paymentAmount}
					onChange={setPaymentAmount}
				/>
			)
		},
	}

	const [selectedClient,setSelectedClient] = useState(null)
	const [nonClient,setNonClient] = useState(false)
	const [nonClientEmail,setNonClientEmail] = useState('')

	useEffect(()=>{
		console.log(invoice)
		if(invoice){
			setSelectedItemType(invoice.item_type)
			setSelectedItemId(invoice.item_id)
			setQty(invoice.qty)
			setPaymentAmount(invoice.amount)
			setDueDate(new Date(invoice.due_date.split(' ').join('T')))
			if(invoice.non_client){
				setNonClient(true)
				setNonClientEmail(invoice.recipient_email)
			}else{
				setNonClient(false)
				setSelectedClient({
					label:invoice.recipient.user_name,
					value:invoice.recipient.user_id_number,
				})
			}
		}
	},[invoice])

	const [isPending,setIsPending] = useState(false)
	const handleSave = ()=>{
		setIsPending(true)
		console.log(selectedItemType,selectedItemId,selectedClient,qty)
		if(!invoice){
			statusDispatch(
				createInvoice({
					recipient_id:nonClient?0:selectedClient.value,
					item_type:selectedItemType,
					item_id:selectedItemId,
					send_email:1,
					non_client:Number(nonClient),
					recipient_email:nonClientEmail,
					amount:paymentAmount,
					due_date:dateToAPIStandard(dueDate),
					qty
				}),
				'invoice',
				'create'
			).then(()=>{
				setIsPending(false)
				reset()
				onHide()
			})
		}else{
			statusDispatch(
				editInvoice({
					id:invoice.id,
					token:invoice.token,
					update:{
						amount:paymentAmount,
						recipient_id:nonClient?0:selectedClient.value,
						item_type:selectedItemType,
						item_id:selectedItemId,
						non_client:Number(nonClient),
						recipient_email:nonClientEmail,
						due_date:dateToAPIStandard(dueDate),
						qty
					}
				}),
				'invoice',
				'create'
			).then(()=>{
				setIsPending(false)
				reset()
				onHide()
			})
		}
		
	}

	const reset = ()=>{
		setSelectedItemType('package')
		setSelectedItemId(0)
		setQty('')
		setNonClient(false)
		setNonClientEmail('')
		setDueDate(new Date())
		setSelectedClient(null)
		setPaymentAmount('')
	}

	const requiresQty = ()=>{
		return ['package','session','merchandise'].includes(selectedItemType)
	}

	const requiresItem = ()=>{
		return ['package','subscription','merchandise'].includes(selectedItemType)
	}

	const selectionIsValid = ()=>{
		//no client selected if sending to a client
		if(!nonClient&&!selectedClient) return false
		//no email specified if sending to a non client
		if(nonClient&&!nonClientEmail) return false
		//invalid qty for item types that require a qty
		if(requiresQty()&&(qty===''||isNaN(parseInt(qty)))) return false
		//no item selected for those that require an item
		if(requiresItem()&&!Boolean(selectedItemId)) return false
		return true
	}

	return (
		<Modal animation={false} show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				Invoice Editor
			</Modal.Header>
			<Modal.Body>
				<strong>
					Select an item type
				</strong>
				<Form.Control
					onChange={e=>{
						setSelectedItemType(e.target.value)
						setSelectedItemId(0)
						setQty('')
						setPaymentAmount('')
					}}
					value={selectedItemType}
					as="select"
					custom
				>
					{Object.entries(optionsMap).map(([k,opt])=>(
						<option key={k} value={k}>{opt.text}</option>
					))}
				</Form.Control>
				{optionsMap[selectedItemType].component}
				{requiresQty()&&
					<>
						<strong>
							Set Qty
						</strong>
						<Form.Control 
							onChange={e=>{
								setQty(e.target.value)
							}}
							value={qty}
							placeholder="Qty"
						/>
					</>
				}
				{!nonClient&&
					<>
						<strong>
							Select a client
						</strong>
						<Select 
							onChange={setSelectedClient}
							value={selectedClient}
							options={clients.map(c=>({
								label:c.user_name,
								value:c.user_id_number
							}))}
						/>
					</>
				}
				{nonClient&&
					<>
						<strong>
							Email
						</strong>
						<Form.Control
							onChange={e=>{
								setNonClientEmail(e.target.value)
							}}
							value={nonClientEmail}
							placeholder="Email"
						/>
					</>
				}
				<strong className="d-block">
					Due Date
				</strong>
				<DatePicker 
					selected={dueDate}
					onChange={setDueDate}
					customInput={<Form.Control className="d-block w-100" size="sm"/>}
					className="mr-1 text-center border rounded" 
					placeholder="due date"
				/>
				<Form.Check
					onChange={e=>{
						setNonClient(e.target.checked)
					}}
					checked={nonClient}
					label="Send invoice to non-client"
					id="non-client-check"
				/>
				<Button
					onClick={handleSave}
					disabled={!selectionIsValid()||isPending}
					className="mt-2"
					variant="outline-success"
					block
				>
					{invoice?'Edit':'Create'} Invoice {isPending&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

export default Editor